module.exports = __webpack_public_path__ + "img/m_top_company.cdc84f92.jpg";